<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-center py-8 justify-center min-h-screen">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>
      <div
        class="bg-white rounded-lg overflow-hidden shadow-xl z-50 px-6 py-6 min-w-[90vw] md:min-w-[40vw]"
      >
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-medium text-gray-800 dark:text-white">
            Actualizar datos del horario
          </h2>
          <button
            @click="isActive"
            class="text-gray-500 hover:text-gray-700 w-8 h-8 flex items-center justify-center hover:bg-gray-200 rounded-lg"
          >
            <svg class="w-5 h-5">
              <use href="../../../assets/svg/icon.svg#cancel" />
            </svg>
          </button>
        </div>
        <LoadingForms v-if="!isLoading" />
        <form class="w-full space-y-6" @submit.prevent v-else>
          <div class="grid md:grid-cols-2 gap-4">
            <label class="block md:col-span-2">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Dias de permanencia
              </span>
              <select
                class="py-2 px-3 text-sm text-gray-600 uppercase border-2 focus:border-blue-500 block w-full rounded-lg mb-2 bg-gray-50 outline-none"
                v-model="dataForm.days"
              >
                <option value="LUNES">LUNES</option>
                <option value="MARTES">MARTES</option>
                <option value="MIéRCOLES">MIERCOLES</option>
                <option value="JUEVES">JUEVES</option>
                <option value="VIERNES">VIERNES</option>
                <option value="SáBADO">SABADO</option>
                <option value="DOMINGO">DOMINGO</option>
              </select>
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Hora de ingreso
              </span>
              <input
                type="time"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 border-green-200 focus:border-blue-500"
                v-model="dataForm.entryTime"
                placeholder="Nombres y apellidos..."
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Tolerancia de ingreso
              </span>
              <input
                type="time"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 border-green-200 focus:border-blue-500"
                v-model="dataForm.toleranceEntryTime"
                placeholder="Nombres y apellidos..."
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Hora de salida
              </span>
              <input
                type="time"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 border-red-200 focus:border-blue-500"
                v-model="dataForm.departureTime"
                placeholder="Nombres y apellidos..."
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Salida máxima
              </span>
              <input
                type="time"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 border-red-200 focus:border-blue-500"
                v-model="dataForm.toleranceDepartureTime"
                placeholder="Nombres y apellidos..."
              />
            </label>
          </div>

          <div class="flex mt-[3.5rem!important]">
            <button
              class="bg-blue-500 text-white px-4 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-blue-600 active:scale-95 flex items-center"
              @click="update"
              :disabled="spinner === true"
            >
              <div class="flex items-center" v-if="spinner">
                <svg class="w-4 h-4 mr-3 animate-spin">
                  <use href="../../../assets/svg/icon.svg#spinnerForBlue" />
                </svg>
                Modificando Información
              </div>
              <span v-else>Modificar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { confirmationOfUpdate, errorActions } from "@/alerts";
import { observer } from "@/observer";
import axios from "../../../api";

//componente de loading
import LoadingForms from "@/components/Loadings/LoadingFormsTwoColumn.vue";
export default {
  name: "UpdateWorkSchedules",
  components: {
    LoadingForms,
  },
  props: {
    activeModal: {
      type: Function,
      required: true,
    },
    getdata: {
      type: Function,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    async function isActive() {
      await props.activeModal(true);
    }

    const registers = ref([]);
    const spinner = ref(false);

    const dataForm = ref({
      days: "LUNES",
      entryTime: "07:00:00",
      departureTime: "17:00:00",
      toleranceEntryTime: "07:10:00",
      toleranceDepartureTime: "17:10:00",
    });

    // el isLoading se aplica para validar que la api aya sido consumido o cargado al 100 y recien ahi cargamos el componente
    const isLoading = ref(false);
    onMounted(async () => {
      const response = await axios
        .get("horarios/" + props.id)
        .catch((error) => errorActions(error));
      registers.value = await response.data;

      dataForm.value.days = registers.value.dias;
      dataForm.value.entryTime = registers.value.hora_de_ingreso;
      dataForm.value.departureTime = registers.value.hora_de_salida;
      dataForm.value.toleranceEntryTime =
        registers.value.hora_de_ingreso_tolerancia;
      dataForm.value.toleranceDepartureTime =
        registers.value.hora_de_salida_tolerancia;

      isLoading.value = true;
    });

    const update = async () => {
      if (dataForm.value.days === null) {
        errorActions("Selecciona un día de permanencia del usuario");
        return;
      }

      spinner.value = true;

      const response = await axios
        .put(
          "horarios/" + props.id,
          {
            days: dataForm.value.days,
            entryTime: dataForm.value.entryTime,
            departureTime: dataForm.value.departureTime,
            toleranceEntryTime: dataForm.value.toleranceEntryTime,
            toleranceDepartureTime: dataForm.value.toleranceDepartureTime,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .catch(function (error) {
          errorActions(error);
        });
      const data = await response.data;
      if (data.msg === true) {
        confirmationOfUpdate(dataForm.value.description);
        setTimeout(async () => {
          //codigo para evitar el error de [resize observer]
          observer.observe(
            document.querySelector(".swal2-container"),
            { box: "content-box" },
            10
          );
          await props.activeModal(false);
          await props.getdata();
        }, 200);
      } else if (data.msg === "Request failed with status code 500") {
        errorActions("Request failed with status code 500");
      } else if (data.status === 404) {
        errorActions(
          "El turno que estas intentando actualizar no existe en nuestra base de datos"
        );
      } else {
        errorActions(
          "Lo sentimos no pudimos actualizar los datos del turno " +
            dataForm.value.description
        );
      }
    };

    return {
      isActive,
      dataForm,
      update,
      isLoading,
      spinner,
    };
  },
};
</script>
